module.exports = __webpack_public_path__ + "img/Resource_apply-1.4f655ae3.png";